import { LOGO_HARFLER, LOGO_ORAN, LOGO_VIEWBOX } from "./logo-yollar";
import { cn } from "@/lib/cn";

/**
 * Vektör kelime markası. Harfler ayrı yol olduğu için tek tek animasyona girebiliyor;
 * mürekkep rengi `currentColor` — tema değişince logo da değişir, ikinci dosya gerekmez.
 */
export function LogoSvg({ height = 26, className, animasyon = false, id = "logo" }: { height?: number; className?: string; animasyon?: boolean; id?: string }) {
  const width = Math.round(height * LOGO_ORAN);
  return (
    <svg
      viewBox={LOGO_VIEWBOX}
      width={width}
      height={height}
      role="img"
      aria-label="OASIS"
      className={cn("block text-ink", animasyon && "logo-cizim", className)}
      style={{ overflow: "visible" }}
    >
      {LOGO_HARFLER.map((h, i) => (
        <path
          key={h.id}
          d={h.d}
          className={cn(h.serit ? "serit" : "harf", animasyon && `h-${i}`)}
          fill={h.serit ? "var(--brand-orange)" : "currentColor"}
          stroke={h.serit ? "var(--brand-orange)" : "currentColor"}
          strokeWidth={animasyon ? 2 : 0}
          pathLength={1}
          data-harf={h.harf}
          id={`${id}-${h.id}`}
        />
      ))}
    </svg>
  );
}
